export const geofenceModel = {

  id: null,
  geofence_id: null,
  name: "",
  description: "",
  category: "",
  area: "",
  group_id: "",
  contract_id: "",
  district_id:null,
  type_id: "",
  owner_id: "",
  type_id:"",
  types:[],
  attributes: []
}
